<template>
	<AppLayout :title="trans('Login')">
		<div class="grow flex flex-col items-center sm:justify-center">
			<img class="m-6 w-[100px] hidden dark:inline-block" :src="storage('/logos/SVG/white/logo.svg')" alt="Logo AArEII">
			<img class="m-6 w-[100px] dark:hidden" :src="storage('/logos/SVG/logo.svg')" alt="Logo AArEII">
			<div class="p-8 flex flex-col gap-8 w-full sm:w-96">
				<form class="flex flex-col items-center md:items-stretch gap-5" @submit.prevent="login">
					<LabeledObject full>
						<template #label>{{ trans('account.email') }}</template>
						<input v-model="credentials.email" type="email" required autocomplete="email" autofocus>
					</LabeledObject>
					<LabeledObject full>
						<template #label>{{ trans('account.password') }}</template>
						<input v-model="credentials.password" type="password" required autocomplete="password">
					</LabeledObject>
					<div class="flex flex-col md:flex-row items-center md:justify-between gap-5">
						<Switch v-model="credentials.remember" :label="trans('Remember me')"/>
						<PrimaryButton :type="ButtonType.Submit" :color="Color.TrueAArEII">
							<i class="fa-solid fa-key mr-2"/>
							{{ trans('Login') }}
						</PrimaryButton>
					</div>
				</form>
			</div>
		</div>
	</AppLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {ref, type Ref} from 'vue'
import {trans} from 'laravel-vue-i18n'
import {router} from '@inertiajs/vue3'
import {Color} from '@/Types/Enums/Color'
import AppLayout from '@/Layouts/AppLayout.vue'
import type Credentials from '@/Types/Credentials'
import {ButtonType} from '@/Types/Enums/ButtonType'
import Switch from '@/Components/UI/Switches/Switch.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import type LoginResponse from '@/Types/Responses/Auth/LoginResponse'
import {showInfo, showSuccess, showValidationErrors, storage} from '@/Helpers/general'

const working:Ref<boolean> = ref(false)
const credentials:Ref<Credentials> = ref({
	email: '',
	password: '',
	remember: false,
})

function login(){
	if(!working.value){
		working.value = true
		showInfo(trans('general.logging_in'))
		axios.post(route('login'), credentials.value).then(({data}:LoginResponse) => {
			showSuccess(trans('general.logged_in'))
			router.get(data)
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>